import { render, staticRenderFns } from "./ApprovalInbox.vue?vue&type=template&id=074f3584&"
import script from "./ApprovalInbox.vue?vue&type=script&lang=js&"
export * from "./ApprovalInbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports